import React, { createContext, useContext, useState } from "react";

const OutputLangContext = createContext(null);

export function OutputLangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("jaanlo_out_lang") || "en");
  const setLang = (l) => { setLangState(l); localStorage.setItem("jaanlo_out_lang", l); };
  const toggle = () => setLang(lang === "en" ? "hi" : "en");
  return <OutputLangContext.Provider value={{ lang, setLang, toggle }}>{children}</OutputLangContext.Provider>;
}

export const useOutputLang = () => useContext(OutputLangContext);
